/**
 * Agent Tool interfaces for agency node configuration.
 * Tools are fetched from the agents API and can be assigned to agent nodes.
 */

export interface AgentTool {
  id: string
  name: string
  description: string
  category: string
  service: string
  endpoint: string
}

export interface AgentToolApiItem {
  tool_id: string
  name: string
  description: string
  category: string
  service: string
  endpoint: string
}

export interface AgentToolsApiResponse {
  items: AgentToolApiItem[]
  total: number
  page: number
  page_size: number
  has_more: boolean
}

export interface AgentToolsListParams {
  page?: number
  pageSize?: number
  category?: string
  service?: string
  search?: string
}

export interface TransformedAgentToolsResponse {
  toolList: AgentTool[]
  total: number
  page: number
  pageSize: number
  hasMore: boolean
}

export const transformAgentToolFromApi = (item: AgentToolApiItem): AgentTool => ({
  id: item.name,
  name: item.name,
  description: item.description,
  category: item.category,
  service: item.service,
  endpoint: item.endpoint,
})

export const transformAgentToolsResponse = (
  response: AgentToolsApiResponse
): TransformedAgentToolsResponse => ({
  toolList: response.items.map(transformAgentToolFromApi),
  total: response.total,
  page: response.page,
  pageSize: response.page_size,
  hasMore: response.has_more,
})
